<template>
    <div class="showBtn">
         <img v-if="(this.$store.state.ResetrouterNavWidth!=0)" @click="hideBlock" src="@/assets/custom-icon/leftBtn.svg"/>
         <img v-else @click="showBlock" src="@/assets/custom-icon/rightBtn.svg"/>
    </div>
</template>
<script>
  import store from '@/utils/store';
  import {setRouterNav} from '@/utils/util'
  export default {
    name: 'Login',
    data:()=>({
       val:""
    }),
    methods:{
      //隐藏 
      hideBlock(){
         store.commit({
            type: "setResetrouterNavWidth",
            ResetrouterNavWidth:0,
         })
      },
      //显示
      showBlock(){
         setRouterNav()
      }
    }
  }
</script>
<style lang="scss" scoped>
     .showBtn{
       width: 14px;
       height: 100%;
       display: flex;
       position: absolute;
       top:0;
       left:-1px;
       justify-content: space-around;
       align-items: center;
       img{
         width: 14px;
         height: 52px;
         cursor: pointer;
       }
     }
</style>
  